// チームの作成・編集（portal.md「チーム管理」/ portal-api.md「チーム」）。チームは人のまとまりで、権限ではない。メンバー画面のポップアップの中身。

import { useState } from "react";
import type { Team } from "../lib/api";

export function TeamEditor({ team, error, onCancel, onSave, onDelete }: {
  team: Team | null; error: string | null; onCancel: () => void;
  onSave: (body: { name: string }) => void; onDelete?: () => void;
}) {
  const [name, setName] = useState(team?.name ?? "");
  return (
    <>
      <p className="muted">チームは部署でも「取引先 X 社」のような単位でもかまいません。所属は任意で、管理者かどうかとは独立です。</p>
      <label htmlFor="team-name">名前</label>
      <input id="team-name" type="text" value={name} autoFocus onChange={(e) => setName(e.target.value)} />
      {error && <p className="error">{error}</p>}
      <p className="row modal-actions">
        {onDelete && <button className="danger" onClick={() => { if (confirm("このチームを削除します。よろしいですか？")) onDelete(); }}>削除</button>}
        <span className="spacer" />
        <button onClick={onCancel}>キャンセル</button>
        <button className="primary" onClick={() => onSave({ name: name.trim() })} disabled={!name.trim()}>保存</button>
      </p>
    </>
  );
}
